
import pgLogo from './logo.svg';
import bhfLogo from './everybeatcounts.png';
import divide from './divide.svg';

function Logo ()
{
    return <div className="flex flex-row gap-4 w-full justify-center align-bottom">
                <img src={pgLogo} className="h-12 sm:h-16" alt="PureGym Logo" />
                <img src={divide} className="h-12 sm:h-16" alt="" />
                <img src={bhfLogo} className="h-12 sm:h-16" alt="British Heart Foundation Logo" />
            </div>
}

export default Logo;